"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgListen = function SvgListen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 17 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#17181A",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.118 8.178c.793-4.616 3.136-6.924 7.03-6.924 5.841 0 6.49 6.16 6.49 7.879 0 1.718-1.376 4.533-2.876 6.197-1 1.109-2.294 3.173-3.884 6.191-1.04 1.779-2.279 2.668-3.714 2.668-2.154 0-4.098-1.646-4.098-4.618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.773 8.266c-.503-2.719-1.806-4.078-3.908-4.078s-3.437.944-4.005 2.83c.09 1.214-.154 2.107-.733 2.68-.87.86-1.29 1.807 0 2.508 1.29.7 1.466 1.862.733 2.612s-2.54 2.11.733 3.705"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgListen);
var _default = exports["default"] = Memo;